var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors != null)?_c('div',_vm._l((_vm.errors),function(item,index){return _c('div',{key:index,staticClass:"text-red"},[_vm._v(" "+_vm._s(_vm.getErrorMessageByCode(item))+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }